export const MetaService = {
  updateMeta(meta) {
    if (meta.title) {
      document.title = meta.title
    }

    this.updateTag('meta[name="description"]', meta.description)
    this.updateTag('link[rel="canonical"]', meta.canonical, 'href')
    this.updateTag('meta[property="og:title"]', meta.title)
    this.updateTag('meta[property="og:description"]', meta.description)
    this.updateTag('meta[property="og:url"]', meta.canonical)
    // Authenticated dashboard pages (appOnly routes) have nothing worth indexing and
    // nothing a crawler could see past the auth gate anyway — noindex keeps them out of
    // search results explicitly rather than relying on robots.txt alone (a crawler that
    // already has a stale link would otherwise still index the page it 404s/redirects on).
    this.updateTag('meta[name="robots"]', meta.noindex ? 'noindex, nofollow' : null)
  },

  updateTag(selector, content, attribute = 'content') {
    if (!content) {
      document.querySelector(selector)?.remove()
      return
    }
    let el = document.querySelector(selector)
    if (!el) {
      if (selector.startsWith('meta')) {
        el = document.createElement('meta')
        const attr = selector.includes('name') ? 'name' : 'property'
        const match = selector.match(/["'](.*)["']/)
        if (match) el.setAttribute(attr, match[1])
      } else if (selector.startsWith('link')) {
        el = document.createElement('link')
        const match = selector.match(/rel=["'](.*)["']/)
        if (match) el.setAttribute('rel', match[1])
      }
      document.head.appendChild(el)
    }
    el.setAttribute(attribute, content)
  },

  injectJsonLd() {
    const existing = document.getElementById('scribe11-jsonld')
    if (existing) existing.remove()

    const script = document.createElement('script')
    script.id = 'scribe11-jsonld'
    script.type = 'application/ld+json'
    script.text = JSON.stringify({
      "@graph": [{
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Scribe11",
        "url": "https://www.scribe11.com",
        "logo": "https://www.scribe11.com/logo.png",
        "accessibilityFeature": ["screenReaderControl", "fullKeyboardControl", "highContrastDisplay"]
      }]
    })
    document.head.appendChild(script)
  }
}
